import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'production') {
  // Fully lazy Sentry — dynamic import keeps the SDK out of the main bundle.
  const initSentry = async () => {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn: 'https://a59589615dec6832645f83fbc3ef6d97@o4511595668635648.ingest.us.sentry.io/4511595717984256',
      environment: 'production',
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    });
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(initSentry, { timeout: 4000 });
  else setTimeout(initSentry, 2000);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for offline support + push notifications.
// When a new SW takes control (e.g. after a deploy), reload once so the page
// drops any in-memory references to stale chunk URLs from the previous build.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            sw.postMessage('SKIP_WAITING');
          }
        });
      });
    }).catch(() => {});

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
